import { FlexColumn, FullContainer } from '@gorila-shared-ui/components';
import { SnackbarProvider } from 'baseui/snackbar';
import { ToasterContainer } from 'baseui/toast';
import { MapProvider } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { EXPANDED_SIDENAV_WIDTH, SIDENAV_WIDTH } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { isLoggedInState, sidenavIsPinnedState } from '../../storage/app';
import { AppProvider } from '../providers/AppProvider';
import { AuthProvider } from '../providers/AuthProvider';
import { JobStatusProvider } from '../providers/JobStatusProvider';
import { Navbar } from '../shared/navbar/Navbar';
import { Sidenav } from '../shared/navbar/Sidenav';
import PageLayout from './PageLayout';

export function FSMLayout() {
  const { css, theme } = useStyles();
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const sidenavIsPinned = useRecoilValue(sidenavIsPinnedState);

  const marginLeft = (() => {
    if (sidenavIsPinned) {
      return `${EXPANDED_SIDENAV_WIDTH}px`;
    }
    return `${SIDENAV_WIDTH}px`;
  })();

  return (
    <MapProvider>
      <SnackbarProvider placement="top">
        <AuthProvider />
        {/* <HeadTitle /> */}
        {isLoggedIn && (
          <>
            <AppProvider />
            <JobStatusProvider />
            <FullContainer flexible>
              <Sidenav />
              <FlexColumn
                classNames={css({
                  flex: 1,
                  overflowX: 'hidden',
                  marginLeft: marginLeft,
                  transition: 'margin-left 0.3s ease-in-out',
                })}
                gap={0}
              >
                <Navbar />
                <PageLayout />
              </FlexColumn>
            </FullContainer>
            <ToasterContainer
              autoHideDuration={2500}
              placement="topRight"
              resetAutoHideTimerOnUpdate
              usePortal={false}
              closeable={true}
              overrides={{
                Root: {
                  style: {
                    marginTop: '64px',
                    marginRight: theme.sizing.scale400,
                  },
                },
              }}
            />
          </>
        )}
      </SnackbarProvider>
    </MapProvider>
  );
}
